import {
  Box,
  Grid,
  Typography,
  TextField,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

const PersonalInfoForm = ({
  personalInfo,
  setPersonalInfo,
  errors,
  setErrors,
  handleNext,
  commonContainerStyle,
}) => {
  const uiFieldStyles = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderRadius: "6px",
      "& fieldset": { borderColor: "#c9c9c9" },
      "&:hover fieldset": { borderColor: "#9d9d9d" },
      "&.Mui-focused fieldset": { borderColor: "#000" },
    },
    "& .MuiInputLabel-root": { color: "#444" },
    "& .MuiFormHelperText-root": { color: "#d32f2f" },
  };
  const navigate = useNavigate();
  // -------------------------
  // VALIDATION FUNCTION
  // -------------------------
  const validateFields = () => {
    const newErrors = {};

    // Name validation
    if (!personalInfo.first_name.trim())
      newErrors.first_name = "First name is required";

    if (!personalInfo.last_name.trim())
      newErrors.last_name = "Last name is required";

    // Gender
    if (!personalInfo.gender) newErrors.gender = "Please select a gender";

    // // DOB validation
    // if (
    //   !personalInfo.dob_dd ||
    //   isNaN(personalInfo.dob_dd) ||
    //   personalInfo.dob_dd < 1 ||
    //   personalInfo.dob_dd > 31
    // )
    //   newErrors.dob_dd = "Invalid day";

    // if (
    //   !personalInfo.dob_mm ||
    //   isNaN(personalInfo.dob_mm) ||
    //   personalInfo.dob_mm < 1 ||
    //   personalInfo.dob_mm > 12
    // )
    //   newErrors.dob_mm = "Invalid month";

    // if (
    //   !personalInfo.dob_yyy ||
    //   isNaN(personalInfo.dob_yyy) ||
    //   personalInfo.dob_yyy < 1900 ||
    //   personalInfo.dob_yyy > new Date().getFullYear()
    // )
    //   newErrors.dob_yyy = "Invalid year";

    // Admission Class
    // if (!personalInfo.admission_class)
    //   newErrors.admission_class = "Class is required";

    // // Category
    // if (!personalInfo.category) newErrors.category = "Category is required";

    // // Nationality
    // if (!personalInfo.nationality)
    //   newErrors.nationality = "Nationality is required";

    // Optional Aadhar — only validate if entered
    // if (personalInfo.aadhar_number) {
    //   if (!/^\d{12}$/.test(personalInfo.aadhar_number)) {
    //     newErrors.aadhar_number = "Aadhar must be a 12-digit number";
    //   }
    // }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleNextClick = () => {
    const valid = validateFields();
    if (valid) handleNext();
  };

  return (
    <Box
      sx={{
        ...commonContainerStyle,
        backgroundColor: "#d8f1f6",
        padding: { xs: 3, sm: 5 },
        borderRadius: "40px 40px 0 0",
        minHeight: "100vh",
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "22px", sm: "24px", md: "28px" },
          fontWeight: 600,
          mb: 3,
        }}
      >
        Personal Information
      </Typography>

      <Grid container spacing={3}>
        {/* NAME */}
        <Grid item xs={12}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            Name*
          </Typography>
        </Grid>

        <Grid item xs={6}>
          <TextField
            fullWidth
            placeholder="First name*"
            sx={uiFieldStyles}
            value={personalInfo.first_name}
            onChange={(e) =>
              setPersonalInfo({ ...personalInfo, first_name: e.target.value })
            }
            error={!!errors.first_name}
            helperText={errors.first_name}
          />
        </Grid>

        <Grid item xs={6}>
          <TextField
            fullWidth
            placeholder="Last name*"
            sx={uiFieldStyles}
            value={personalInfo.last_name}
            onChange={(e) =>
              setPersonalInfo({ ...personalInfo, last_name: e.target.value })
            }
            error={!!errors.last_name}
            helperText={errors.last_name}
          />
        </Grid>

        {/* GENDER */}
        <Grid item xs={12} md={4}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Gender*
          </Typography>

          <FormControl fullWidth error={!!errors.gender} sx={uiFieldStyles}>
            <Select
              value={personalInfo.gender}
              displayEmpty
              onChange={(e) =>
                setPersonalInfo({ ...personalInfo, gender: e.target.value })
              }
            >
              <MenuItem value="">
                <em>Select Gender</em>
              </MenuItem>
              <MenuItem value="male">Male</MenuItem>
              <MenuItem value="female">Female</MenuItem>
              <MenuItem value="other">Other</MenuItem>
            </Select>

            {errors.gender && <FormHelperText>{errors.gender}</FormHelperText>}
          </FormControl>
        </Grid>

        {/* DOB */}
        {/* <Grid item xs={12} md={8}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            Date of Birth*
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                fullWidth
                label="DD"
                sx={uiFieldStyles}
                value={personalInfo.dob_dd}
                onChange={(e) =>
                  setPersonalInfo({ ...personalInfo, dob_dd: e.target.value })
                }
                error={!!errors.dob_dd}
                helperText={errors.dob_dd}
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                fullWidth
                label="MM"
                sx={uiFieldStyles}
                value={personalInfo.dob_mm}
                onChange={(e) =>
                  setPersonalInfo({ ...personalInfo, dob_mm: e.target.value })
                }
                error={!!errors.dob_mm}
                helperText={errors.dob_mm}
              />
            </Grid>

            <Grid item xs={4}>
              <TextField
                fullWidth
                label="YYYY"
                sx={uiFieldStyles}
                value={personalInfo.dob_yyy}
                onChange={(e) =>
                  setPersonalInfo({ ...personalInfo, dob_yyy: e.target.value })
                }
                error={!!errors.dob_yyy}
                helperText={errors.dob_yyy}
              />
            </Grid>
          </Grid>
        </Grid> */}

        {/* ADMISSION CLASS */}
        {/* <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Class for Admission*
          </Typography>

          <FormControl fullWidth error={!!errors.admission_class} sx={uiFieldStyles}>
            <Select
              value={personalInfo.admission_class}
              displayEmpty
              onChange={(e) =>
                setPersonalInfo({
                  ...personalInfo,
                  admission_class: e.target.value,
                })
              }
            >
              <MenuItem value="" disabled>
                Select class
              </MenuItem>
              {Array.from({ length: 12 }, (_, i) => (
                <MenuItem key={i} value={i + 1}>
                  Class {i + 1}
                </MenuItem>
              ))}
            </Select>

            {errors.admission_class && (
              <FormHelperText>{errors.admission_class}</FormHelperText>
            )}
          </FormControl>
        </Grid> */}

        {/* CATEGORY */}
        {/* <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Category*
          </Typography>

          <FormControl fullWidth error={!!errors.category} sx={uiFieldStyles}>
            <Select
              value={personalInfo.category}
              displayEmpty
              onChange={(e) =>
                setPersonalInfo({ ...personalInfo, category: e.target.value })
              }
            >
              <MenuItem value="" disabled>
                Select category
              </MenuItem>
              <MenuItem value="general">General</MenuItem>
              <MenuItem value="obc">OBC</MenuItem>
              <MenuItem value="sc">SC</MenuItem>
              <MenuItem value="st">ST</MenuItem>
            </Select>

            {errors.category && (
              <FormHelperText>{errors.category}</FormHelperText>
            )}
          </FormControl>
        </Grid> */}

        {/* NATIONALITY */}
        {/* <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Nationality*
          </Typography>

          <FormControl fullWidth error={!!errors.nationality} sx={uiFieldStyles}>
            <Select
              value={personalInfo.nationality}
              displayEmpty
              onChange={(e) =>
                setPersonalInfo({ ...personalInfo, nationality: e.target.value })
              }
            >
              <MenuItem value="" disabled>
                Select country
              </MenuItem>
              <MenuItem value="Indian">Indian</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>

            {errors.nationality && (
              <FormHelperText>{errors.nationality}</FormHelperText>
            )}
          </FormControl>
        </Grid> */}

        {/* AADHAR */}
        {/* <Grid item xs={12} md={6}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Aadhar number (if applicable)
          </Typography>

          <TextField
            fullWidth
            sx={uiFieldStyles}
            placeholder="Enter Aadhar Number"
            value={personalInfo.aadhar_number}
            onChange={(e) =>
              setPersonalInfo({
                ...personalInfo,
                aadhar_number: e.target.value,
              })
            }
            error={!!errors.aadhar_number}
            helperText={errors.aadhar_number}
          />
        </Grid> */}

        {/* FOOTER BUTTONS */}
        <Grid item xs={12} display="flex" justifyContent="space-between" mt={5}>
          <Button
            variant="contained"
            onClick={() => {
              navigate("/initial-info");
            }}
            sx={{
              backgroundColor: "#2C2C2C",
              color: "white",
              padding: "6px 28px",
              borderRadius: "6px",
              "&:hover": { backgroundColor: "#444" },
            }}
          >
            Back
          </Button>
          <Box sx={{ display: "flex" }}>
            <Typography sx={{ fontSize: "12px", mr: 2 }}>
              *imp fields
            </Typography>
            <Button
              variant="contained"
              onClick={(e) => handleNext(e)}
              sx={{
                backgroundColor: "#2C2C2C",
                color: "white",
                padding: "6px 28px",
                borderRadius: "6px",
                "&:hover": { backgroundColor: "#444" },
              }}
            >
              Next
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PersonalInfoForm;
